import {Injectable} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {from, Observable} from "rxjs";
import {SelectRegistrantTypeModalComponent} from "./select-registrant-type-modal.component";
import {RegistrantType} from "../../../../../../generated-model/model";

@Injectable({providedIn: 'root'})
export class SelectRegistrantTypeService {

  constructor(private modalService: NgbModal) {
  }

  open(): Observable<RegistrantType> {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(SelectRegistrantTypeModalComponent, {
      backdrop: 'static',
      centered: true,
      size: "lg"
    });
    return from(modalRef.result)
  }
}
